import './Hero.css';

export default function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero__content">
        <p className="hero__eyebrow animate-fade-up delay-1">Bonjour, je suis</p>
        <h1 className="hero__name animate-fade-up delay-2">
          Eren <span className="keyword">Varli</span>
        </h1>
        <p className="hero__title animate-fade-up delay-3">
          <span className="keyword">Architecte</span> <span className="keyword">de Systèmes d'Information</span>
        </p>
        <p className="hero__tagline animate-fade-up delay-4">
          Je construis pour combiner <span className="keyword">performance</span>,{' '}
          <span className="keyword">stratégie</span> et <span className="keyword">impact</span>.
        </p>
        <div className="hero__cta animate-fade-up delay-5">
          <a href="#projects" className="btn btn--primary">Voir mes projets</a>
          <a href="#contact" className="btn btn--ghost">Me contacter</a>
        </div>
      </div>
      <div className="hero__bg" aria-hidden="true">
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
      </div>
    </section>
  );
}
